import { NgClass} from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoFocus } from 'primeng/autofocus';
import { Checkbox } from 'primeng/checkbox';
import { InputMask } from 'primeng/inputmask';
import { InputText } from 'primeng/inputtext';
import { SelectButton } from 'primeng/selectbutton';
import { CustomerGroup } from '../../../enums/organisation/customer-group';
import { PaymentMethodName } from '../../../enums/payment/payment-method-name';
import { BaseAddPaymentComponent } from '../../base/base-add-payment.component';

@Component({
  selector: 'add-form-payment',
  imports: [
    SelectButton,
    FormsModule,
    InputText,
    Checkbox,
    InputMask,
    NgClass,
    AutoFocus
  ],
  templateUrl: './add-form-payment.component.html'
})
export class AddFormPaymentComponent extends BaseAddPaymentComponent {

  protected readonly PaymentMethodName = PaymentMethodName;
  protected readonly CustomerGroup = CustomerGroup;
}
